const mapStateToProps = state => ({
    deviceIsOnline: state.deviceIsOnline
});

export default mapStateToProps;
